export default (param) => {
  if (param === 200) {
    return true;
  }

  return false;
};

